export const errorDataDetailModalTranslationJP = {
  ErrorDataDetailModal: {
    head_title: 'エラー詳細',
    store_cd: '店舗コード',
    store_name: '店舗店舗名',
    rearrange_menu: 'メニュー再配置',
    selection: '選択',
    menu_or_menu_subtitle_cd: 'メニューコード／<br/>サブタイトルメニューコード',
    menu_name: 'メニュー名',
    pos_cd: 'POSコード',
    pos_name: 'POS名',

    // A-031 feature #16
    overview_error_info1:
      'ファイルの取込が完了致しましたが、以下POSコードは取込に失敗しました。メッセージをご確認ください。',
    // A-003 feature #3
    overview_error_info2:
      '食材管理システム登録漏れチェックの結果、以下のエラーが発生しました。メッセージをご確認ください。',
    // A-029 feature #14
    overview_error_info3: '配信設定チェックの結果、以下のエラーが発生しました。メッセージをご確認ください。',

    //patern 1a
    warn_has_unregister_default: 'メニューに割り当てられていないPOSコードがTMS_MST_MLU.csvに{0}件存在します。',
    //patern 1b
    warn_has_unregister_over_limit:
      'メニューに割り当てられていないレジ情報がTMS_MST_MLU.csvに{0}件以上存在します。食材管理システムの登録状況を確認してください。',
    //pattern 2
    warn_invalid_pos_code:
      'TMS_MST_MLU.csvとTMS_MST_MENUCONST.csvの両方に存在するPOSコードが存在します。オーサリングツールではどちらか一方のメニューとしての設定しか出来ません。レジ設定をご確認ください。<br>注）このPOSコードはインポートされていませんので必要な場合は、レジ情報の設定を変更後、再度、レジパターンをインポートしてください。',
    //pattern 3
    warn_menu_has_poscode_in_main_and_sub_menu:
      '一つのメニューに関連する複数のPOSコードがそれぞれ通常メニューとサブメニューの両方に存在します。食材管理システムの登録を変更するか、本ツール上でメニューの再配置を行ってください。',
    //pattern 4
    warn_has_multiple_registered:
      '一つのメニューに有効なPOSコードがTMS_MST_MLU.csvに複数存在します。<br>食材管理システムの登録を変更するか、本ツール上でメニューの再配置を行ってください。',
    //pattern 5
    warn_poscode_used_in_multiple_menu_subtitle_menu:
      '同じPOSコードがメニューとサブタイトルメニューに存在します。メニューを削除するか食材管理システムの登録を変更してください。',

    warn_rearrange_menu_successful:
      'メニュー再配置が完了しました。新たに配置したメニューのメニューブック、バー案内の設定がある場合は、再設定してください。',
  },
};
